/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleBookingStatusesRequest
 */
export interface VehicleBookingStatusesRequest {
    /**
     * VehicleBooking ids to resolve.
     * @type {Array<number>}
     * @memberof VehicleBookingStatusesRequest
     */
    bookingIds: Array<number>;
}

/**
 * Check if a given object implements the VehicleBookingStatusesRequest interface.
 */
export function instanceOfVehicleBookingStatusesRequest(value: object): value is VehicleBookingStatusesRequest {
    if (!('bookingIds' in value) || value['bookingIds'] === undefined) return false;
    return true;
}

export function VehicleBookingStatusesRequestFromJSON(json: any): VehicleBookingStatusesRequest {
    return VehicleBookingStatusesRequestFromJSONTyped(json, false);
}

export function VehicleBookingStatusesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleBookingStatusesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingIds': json['booking_ids'],
    };
}

export function VehicleBookingStatusesRequestToJSON(json: any): VehicleBookingStatusesRequest {
    return VehicleBookingStatusesRequestToJSONTyped(json, false);
}

export function VehicleBookingStatusesRequestToJSONTyped(value?: VehicleBookingStatusesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_ids': value['bookingIds'],
    };
}

